<template>
  <div class="store-card">
    <div class="body">
      <div class="content">
        <div class="title">
          {{ item.shopName }}
        </div>
        <div class="tags">
          <span>{{ { 1: "营业中", 2: "休息中" }[item.businessStatus] }}</span>
          <span
            v-for="label in item.shopLabels"
            :key="label"
          >
            {{ label }}
          </span>
        </div>
        <div class="address">
          <i class="hb-icon hb-icon-address-3" />
          <span>{{ item.addressInfo }}</span>
        </div>
        <div class="time">
          <i class="hb-icon hb-icon-clock-3" />
          <span> {{ item.businessTime }}</span>
        </div>
      </div>
    </div>
    <div class="icons">
      <div
        class="phone-icon"
        @click="telPhone(item.shopPhone)"
      >
        <i class="hb-icon hb-icon-shop_phone" />
        <span>电话</span>
      </div>
      <div
        class="nav-icon"
        @click="goLocation(item)"
      >
        <i class="hb-icon hb-icon-shop_guide" />
        <span>导航</span>
      </div>
    </div>
  </div>
</template>

<script>

import shop from '@/assets/shop/shop.png';
import { loadHbridge } from '@/utils/globalLoader';

export default {
  name: 'StoreCard',
  props: {
    item: {
      type: Object,
      default: () => ({
        shopId: '',
        shopName: '',
        merchantId: '',
        businessTime: '',
        businessStatus: '',
        shopLabels: [],
        addressInfo: '',
        shopPhone: '',
        shopImages: [],
        shopHeadCover: '',
        lng: '',
        lat: '',
      }),
    },
  },

  data() {
    return {
      imgOnError: `this.src="${shop}"`,
    };
  },

  mounted() {
    import('vant/lib/image-preview/style/index'); // eslint-disable-line
  },


  methods: {
    async goLocation(item) {
      const {
        lng,
        lat,
        shopName,
        addressInfo,
      } = item;
      const { Native } = await loadHbridge();
      Native.callNative({
        method: 'openNavi',
        classMap: 'SwitchBridge',
        params: {
          lng, lat, name: shopName, address: addressInfo,
        },
      });
    },

    telPhone(shopPhone) {
      window.location.href = `tel:${shopPhone}`;
    },
  },

};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>
